module.exports = __webpack_public_path__ + "media/images/lesson_5/caras-e00a4caecbf06cab4bbb5c6021e1810e.jpg";